import * as yup from "yup";

export const schema = yup.object().shape({
  email: yup
    .string()
    .email("O e-mail deve ser formatado corretamente")
    .required("Preencha esse campo obrigatório."),
  prrequisito_computador: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  prrequisito_disponibilidade: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  kenzie_empregabilidade: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  kenzie_atendimento: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  kenzie_formacao: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  kenzie_pagamento: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  privacy: yup
    .boolean()
    .typeError("")
    .oneOf([true], "Preencha esse campo obrigatório.")
    .required("Preencha esse campo obrigatório."),
});
